<template>
  <div class="home">
    <div
      class="hero"
      :style="{
        backgroundImage: 'url(' + require('@/assets/img/hero.jpg') + ')',
      }"
    >
      <div class="dark"></div>
      <div class="contain">
        <h1>The COVID-19 Survey.</h1>
        <p>
          Get ready to the new normal by asking your employees and visitors CDC
          recommended questions before they get back to work or your business,
          Protect your employees and customers.
        </p>
        <div class="btns">
          <button @click="$router.push({ path: '/register' })" class="btn">
            Register
          </button>
          <button @click="showLogin()" class="btn text_btn">Login</button>
        </div>
      </div>
    </div>

    <div class="img-text">
      <div class="contain">
        <div class="text">
          <h2>Keeping Everyone Safe.</h2>
          <p>
            As many businesses are preparing to open up and employees coming
            back to work, it's important to ask each person coming back to work
            or to your business a few questions, Did they get Covid 19, where
            they in touch with someone who did and more, set an automatic
            web/mobile page for your employees and visitors to answer simple
            Yes/No questions.
          </p>
          <div class="btns">
            <button @click="$router.push({ path: '/register' })" class="btn">
              Get Started
            </button>
          </div>
        </div>
        <div>
          <img :src="config.HOME_IMAGE" />
        </div>
      </div>
    </div>

    <div class="img-text right color logo-text">
      <div class="contain">
        <div class="text">
          <h2>Used By Companies All Over The World.</h2>
          <p>
            We've been trusted by many to save time and improve safety duing
            these troubling times. Let us know if you have any questions.
          </p>

          <div class="inputs contact-form">
            <div class="input">
              <label>First Name <span class="required">*</span></label>
              <input type="text" v-model="contact.first_name" />
            </div>
            <div class="input">
              <label>Last Name <span class="required">*</span></label>
              <input type="text" v-model="contact.last_name" />
            </div>
            <div class="input">
              <label>Email Address <span class="required">*</span></label>
              <input type="text" v-model="contact.email" />
            </div>
            <div class="input">
              <label>Phone Number <span class="required">*</span></label>
              <vue-tel-input v-model="contact.phone"></vue-tel-input>
            </div>
            <div class="input full">
              <label>Comments <span class="required">*</span></label>
              <textarea
                :draggable="false"
                v-model="contact.comments"
              ></textarea>
            </div>

            <div class="btns right form-btn">
              <transition name="fade-quick">
                <div>
                  <button
                    @click="validate()"
                    v-if="status == 'submit'"
                    class="btn"
                  >
                    Reach Out
                  </button>
                  <transition name="fade-quick">
                    <p v-if="feedback" class="error">{{ feedback }}</p>
                  </transition>
                </div>
              </transition>
              <transition name="fade-quick">
                <img
                  class="loader"
                  v-if="status == 'loading'"
                  src="@/assets/img/loader.gif"
                />
              </transition>
              <transition name="fade-quick">
                <div class="success" v-if="status == 'success'">
                  <p>
                    Thanks!
                    <span>We'll get back to you shortly.</span>
                  </p>
                </div>
              </transition>
            </div>
          </div>
        </div>
        <div class="logos">
          <img src="@/assets/img/logo1.png" />
          <img src="@/assets/img/logo3.png" />
          <img src="@/assets/img/logo4.png" />
          <img src="@/assets/img/logo5.png" />
          <img src="@/assets/img/logo6.png" />
          <img src="@/assets/img/logo7.png" />
          <img src="@/assets/img/logo8.png" />
          <img src="@/assets/img/logo9.png" />
          <img src="@/assets/img/logo10.png" />
        </div>
      </div>
    </div>

    <div class="facts">
      <div class="contain">
        <h2>What you get.</h2>
        <ul class="facts">
          <li>Customize your landing pages with your company logo</li>
          <li>Manage questions and answer options</li>
          <li>Add employees or bulk upload</li>
          <li>Invite visitors</li>
          <li>Manage by locations</li>
          <li>Set automatic reminders and auto sending</li>
          <li>Enable QR reader for faster checking</li>
          <li>Integration to your HR platform</li>
          <li>See usage reports of employees and visitors</li>
          <li>Platform analytics</li>
        </ul>
        <button @click="goToSurvyio('/pricing')" class="btn reverse">
          See Pricing
        </button>
      </div>
    </div>

    <register></register>

    <foot></foot>
  </div>
</template>

<script>
import Popup from "@/components/Popup";
import Footer from "@/components/Footer";
import Register from "@/components/Register";
import firebase from "firebase";
import axios from "axios";
import Swal from "sweetalert2";

const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const functions = fb.default.functions;

export default {
  name: "home",
  components: {
    popup: Popup,
    register: Register,
    foot: Footer,
  },
  data() {
    return {
      user: {
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        comments: null,
      },
      contact: {
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        comments: null,
      },
      status: "submit",
      feedback: "",
      sendEmail: functions.httpsCallable("sendEmail"),
    };
  },
  mounted() {},
  async created() {
    await this.getAffiliates();
  },
  updated() {},
  methods: {
    validate() {
      let valid = true;
      let contact = this.contact;

      for (let key in contact) {
        if (!contact[key]) valid = false;
      }

      if (valid) {
        this.sendContact();
      } else {
        this.feedback = "Please enter all required fields";
      }
    },
    sendContact() {
      this.status = null;
      this.feedback = null;
      this.sendEmail({
        template_name: "covid-19-send-contact",
        to_email: [
          {
            email: "eitan@emagid.com",
            type: "to",
          },
        ],
        from_email: null,
        global_merge_vars: [
          {
            name: "name",
            content: this.contact.first_name + " " + this.contact.last_name,
          },
          {
            name: "email",
            content: this.contact.email,
          },
          {
            name: "phone",
            content: this.contact.phone,
          },
          {
            name: "comments",
            content: this.contact.comment,
          },
        ],
        message: null,
      })
        .then((response) => {
          setTimeout(() => {
            this.status = "success";
            this.contact = {
              first_name: null,
              last_name: null,
              email: null,
              phone: null,
              comments: null,
            };
          }, 500);
        })
        .catch(function(error) {
          console.log(error);
          Swal.fire("Could not send email");
        });
    },
  },
};
</script>

<style lang="scss">
.hero {
  position: relative;
  height: 100vh;
  min-height: 600px;
  background-size: cover;
  background-position: center;
  @media screen and (max-width: 600px) {
    height: auto;
  }
  .dark {
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 0;
    background: linear-gradient(rgba(36, 51, 68, 0), #17262b);
  }
  .contain {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    height: 100%;
    padding-bottom: 75px;
    h1 {
      color: white;
      max-width: 1000px;
      @media screen and (max-width: 700px) {
        font-size: 58px;
      }
    }
    p {
      color: white;
      max-width: 700px;
      font-size: 18px;
      margin-bottom: 40px;
      @media screen and (max-width: 900px) {
        font-size: 17px;
      }
    }
  }
}

.img-text {
  .contain {
    display: flex;
    align-items: center;
    justify-content: space-between;
    @media screen and (max-width: 900px) {
      flex-direction: column;
      padding-top: 50px;
      padding-bottom: 50px;
    }
    .text {
      max-width: 500px;
      @media screen and (max-width: 900px) {
        max-width: 100%;
      }
      h2 {
        font-size: 36px;
        margin-top: 20px;
        margin-bottom: 35px;
        font-weight: bold;
        @media screen and (min-width: 1500px) {
          font-size: 50px;
        }
      }
      .btns {
        margin-top: 40px;
        &.form-btn {
          margin-top: 0;
        }
        @media screen and (max-width: 900px) {
          margin-bottom: 40px;
          margin-top: 20px;
        }
      }
    }
    img {
      max-width: 375px;
      @media screen and (max-width: 1100px) {
        max-width: 350px;
      }
      @media screen and (max-width: 900px) {
        max-width: 300px;
        width: 100%;
      }
    }
  }
  &.color {
    background-color: white;
  }
  &.right {
    .contain {
      flex-direction: row-reverse;
      @media screen and (max-width: 900px) {
        padding-top: 50px;
        flex-direction: column;
      }
    }
  }
}

.facts {
  background: #00bf6f;
  h2 {
    color: white;
  }
  ul {
    list-style: none;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    li {
      background: rgba(255, 255, 255, 0.16);
      padding: 10px 20px;
      border-radius: 5px;
      margin: 5px 10px;
      margin-left: 0;
      color: white;
    }
  }
}

.contact-form {
  margin-top: 50px;
}

.logo-text {
  .contain {
    @media screen and (max-width: 1100px) {
      flex-wrap: wrap;
    }
    .text {
      @media screen and (max-width: 1100px) {
        width: 100%;
        max-width: 100%;
      }
    }
    .logos {
      width: 48%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      @media screen and (max-width: 1100px) {
        width: 100%;
        margin-top: 30px;
      }
      img {
        margin: 20px;
        max-height: 60px !important;
        max-width: 150px !important;
        width: auto;
        @media screen and (max-width: 1100px) {
          max-height: 60px !important;
          max-width: 120px !important;
          margin: 15px;
        }
      }
    }
  }
}
</style>
